import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/plugins/vue-i18n'

import statementsRoutes from '@/router/statements.routes'
import statementsManualRoutes from '@/router/statementsManual.routes'
import measurementsRoutes from '@/router/measurements.routes'
import settingsRoutes from '@/router/settings.routes'
import branchesRoutes from '@/router/branches.routes'
import technicalControlRoutes from '@/router/technicalControl.routes'

import store from '../store'
import { access } from '@/configs/permissions'


Vue.use(Router)

export const routes = [
  ...statementsRoutes,
  ...statementsManualRoutes,
  ...measurementsRoutes,
  ...settingsRoutes,
  ...branchesRoutes,
  ...technicalControlRoutes,
  {
    path: '*',
    name: 'all',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'no-found',
    meta: {
      public: true,
      access: 'public'
    },
    component: () => import('@/views/NotFound')
  },
  {
    path: '/',
    name: 'main',
    meta: {
      access: 'statementView'
    },
    redirect: '/statements'
  },
  {
    path: '/create-account',
    name: 'create-account',
    meta: {
      access: 'guestUser'
    },
    component: () => import('@/views/AccountInfotrans/Create')
  },
  {
    path: '/success',
    name: 'success',
    meta: {
      access: 'guestUser'
    },
    component: () => import('@/views/AccountInfotrans/Success')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      access: 'searchView'
    },
    component: () => import('@/views/Search/ResultPage'),
  },
  {
    path: '/cabinet',
    name: 'cabinet',
    meta: {
      access: 'statementActionDirectorCertification'
    },
    component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Cabinet'),
    children: [
      {
        path: 'workers',
        name: 'workers',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Workers/List')
      },
      {
        path: 'workers/add-workers',
        name: 'addWorkers',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Workers/Add')
      },
      {
        path: 'workers/edit/:id',
        name: 'editWorker',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Workers/Edit')
      },
      {
        path: 'workers/:id',
        name: 'viewWorker',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Workers/Worker')
      },
      {
        path: 'branch-offices',
        name: 'branchOffices',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/BranchOffices/List')
      },
      {
        path: 'contracts',
        name: 'listContractsOC',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Contracts/List')
      },
      {
        path: 'contracts/add',
        name: 'addContractOC',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/Contract/AddAndUpdateContract')
      },
      {
        path: 'contracts/update/:id',
        name: 'updateContractOC',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/Contract/AddAndUpdateContract')
      },
      {
        path: 'branch-offices/add',
        name: 'addBranchOffice',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/BranchOffices/Add')
      },
      {
        path: 'branch-offices/:id',
        name: 'branchOffice',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () =>
          import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/BranchOffices/BranchOffice')
      },
      {
        path: 'branch-offices/edit/:id',
        name: 'editBranchOffice',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () =>
          import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/BranchOffices/UpdateOffice')
      },
      {
        path: 'documents',
        name: 'documentsInfo',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Documents/Info')
      },
      {
        path: 'documents/edit',
        name: 'documentsEdit',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Documents/Edit')
      },
      {
        path: 'statistics',
        name: 'statistics',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/Statistics'),
        children: [
          {
            path: 'authorities-certificate',
            name: 'authoritiesCertificate',
            meta: {
              access: 'statementActionDirectorCertification'
            },
            // eslint-disable-next-line vue/max-len
            component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/AuthoritiesCertificate')
          },
          {
            path: 'register-standard',
            name: 'registerStandard',
            meta: {
              access: 'statementActionDirectorCertification'
            },
            // eslint-disable-next-line vue/max-len
            component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/RegisterStandardUkraine/WrapperRegisterStandardUkraine')
          },
        ]
      },
      {
        path: 'statistics/register-standard/uas-key-edit',
        name: 'uasKeyEdit',
        meta: {
          access: 'statementActionDirectorCertification'
        },
        // eslint-disable-next-line vue/max-len
        component: () => import('@/views/OrganizationRegistration/CertificationAgency/Cabinet/Items/RegisterStandardUkraine/EditCardInfo')
      },
    ]
  },
  {
    path: '/server-error',
    name: 'server-error',
    meta: {
      public: true
    },
    component: () => import('@/views/Error')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      public: true
    },
    component: () => import('@/views/SignIn')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    meta: {
      public: true
    },
    component: () => import('@/views/ForgotPassword')
  },
  {
    path: '/forgot',
    name: 'forgot',
    meta: {
      public: true
    },
    component: () => import('@/views/RecoveryPassword')
  },
  {
    path: '/auth',
    name: 'auth',
    meta: {
      public: true
    },
    component: () => import('@/views/SignInQR')
  },
  {
    path: '/preview/:link',
    name: 'preview-file',
    meta: {
      access: 'statementView'
    },
    component: () => import('@/components/PreviewFile')
  }
]

let startCheckingRegistrationProfileExists = false

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  scrollBehavior (to, from, savedPosition) {
    let scrollTop = 0

    let isExplanationNavigation =
      (!Object.keys(from.query).length && !!Object.keys(to.query).length && to.query.hasOwnProperty('explanation')) ||
      (!Object.keys(to.query).length && !!Object.keys(from.query).length && from.query.hasOwnProperty('explanation'))
    // || (!Object.keys(from.query).length && !!Object.keys(to.query).length && to.query.hasOwnProperty('field')) ||
    // (!Object.keys(to.query).length && !!Object.keys(from.query).length && from.query.hasOwnProperty('field'))

    if (isExplanationNavigation) scrollTop = window.top.scrollY

    if (savedPosition || from.name === 'search') return savedPosition

    return { x: 0, y: scrollTop }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (store.getters.getLoadStatusMeasurement) {
    Vue.prototype.$swal(i18n.t('waitFinishOperation'))
  } else {
    if (from.name === to.name && JSON.stringify(from.query) !== JSON.stringify(to.query)) {
      next()
    } else {
      const isAuth = Vue.prototype.$auth.isAuth()
      let profile = store.state.profile.profile
      store.commit('SET_LOAD', false)

      if (isAuth) {
        if (Object.keys(profile).length) {
          store.commit('SET_LOAD', true)
          if (to.name === 'no-found' || to.name === 'server-error') next()
          else if (to.meta.public) next('/')
          else access(to.meta.access) ? next() : next('/404')
          if (!startCheckingRegistrationProfileExists) profileExists(to, next)
        } else {
          store.dispatch('getProfile')
            .then(() => {
              if (to.name === 'no-found' || to.name === 'server-error') next()
              else if (to.meta.public) next('/')
              else access(to.meta.access) ? next() : next('/404')
            })
            .finally(() => {
              store.commit('SET_LOAD', true)
              if (!startCheckingRegistrationProfileExists) profileExists(to, next)
            })
        }
      } else {
        store.commit('SET_LOAD', true),
          ['login', 'auth', 'forgot-password', 'forgot'].includes(to.name) ? next() : next('/login')
      }
    }
  }
})

function profileExists (to, next) {
  startCheckingRegistrationProfileExists = true
  let { certification_statement, laboratory_statement } = store.state.profile.profile
  let OC = !!(certification_statement && Object.keys(certification_statement).length)
  let VL = !!(laboratory_statement && Object.keys(laboratory_statement).length)
  let isDirectorOC = access('statementActionDirectorCertification')
  let isGuest = access('guestUser')
  let isCreateAccSuccess = localStorage.getItem('createAccountSuccess') === 'create_account_success'

  // has statement VL
  if (VL) {
    if (!laboratory_statement?.is_finished) next('/create-account')
    else {
      next('/success')
      localStorage.setItem('createAccountSuccess', 'create_account_success')
    }
  }
  // has statement OC
  else if (OC) {
    if (!certification_statement?.is_finished) next({ name: 'create-account', query: to.query })
    else {
      next('/success')
      localStorage.setItem('createAccountSuccess', 'create_account_success')
    }
  } else if (isGuest && !OC && !VL) {
    next('/create-account')
  }
  // after approved OC/VL
  else if (isCreateAccSuccess) {
    next(`${ isDirectorOC ? '/cabinet/statistics/authorities-certificate' : '/laboratory/statistic' }`)
    localStorage.removeItem('createAccountSuccess')
  }
  startCheckingRegistrationProfileExists = false
}

export default router
